import request from "./http";

class PermissionRepository
{
    async getAllByRoleId(roleId) {
        const path = "permissions/role";
        const method = "GET";
        const data = {
            role_id: roleId
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get all", error);
        }
    }

    async getAllByUserId(userId) {
        const path = "permissions/user";
        const method = "GET";
        const data = {
            user_id: userId
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("get all", error);
        }
    }

    async syncByRoleId(permissions, roleId) {
        const path = "permissions/sync";
        const method = "POST";
        const data = {
            user_id: null,
            role_id: roleId,
            permissions: permissions
        };

        try {
            const response = await request(path, method, data);      

            return response.data;
        } catch (error) {
            console.error("syncByRoleId", error);
        }
    }

    async syncByUserId(permissions, userId) {
        const path = "permissions/sync";
        const method = "POST";
        const data = {
            role_id: null,
            user_id: userId,
            permissions: permissions
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("create", error);
        }
    }

    async getAllByCurrentUser() {
        const path = "permissions/current-user";
        const method = "GET";
        const data = null;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error("create", error);
        }
    }
}

export default PermissionRepository;